/**
 * PWA 감지 유틸리티
 * PWA로 설치되어 실행 중인지 웹 브라우저에서 실행 중인지 구분합니다.
 */

/**
 * 현재 앱이 PWA 모드로 실행 중인지 확인합니다.
 * @returns {boolean} PWA 모드면 true, 웹 브라우저 모드면 false
 */
export function isPWA(): boolean {
  // 1. Standalone 모드 확인 (Android Chrome, iOS Safari 등)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }

  // 2. iOS Safari standalone 모드 확인
  if ((window.navigator as any).standalone === true) {
    return true;
  }

  // 3. Minimal UI 모드 확인
  if (window.matchMedia('(display-mode: minimal-ui)').matches) {
    return true;
  }

  // 4. Service Worker가 등록되어 있고 standalone으로 실행 중인지 확인
  if ('serviceWorker' in navigator) {
    // Service Worker가 활성화되어 있으면 PWA로 간주할 수 있음
    // 단, 이것만으로는 확실하지 않으므로 위의 방법들을 우선 사용
  }

  // 5. URL 파라미터로 확인 (필요시 사용)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('pwa') === 'true') {
    return true;
  }

  return false;
}

/**
 * PWA 설치 가능 여부를 확인합니다.
 * @returns {boolean} 설치 가능하면 true
 */
export function isInstallable(): boolean {
  // BeforeInstallPrompt 이벤트가 발생했는지 확인
  return (window as any).deferredPrompt !== undefined;
}

/**
 * PWA 설치 프롬프트를 표시합니다.
 * @returns {Promise<boolean>} 설치 성공 여부
 */
export async function promptInstall(): Promise<boolean> {
  const deferredPrompt = (window as any).deferredPrompt;
  if (!deferredPrompt) {
    return false;
  }

  try {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    (window as any).deferredPrompt = null;
    return outcome === 'accepted';
  } catch (error) {
    console.error('PWA 설치 프롬프트 오류:', error);
    return false;
  }
}

